import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { formatAddressBlock } from '#/modules/crmMgmt/helper/formatAddressBlock';

const CrmAddressCard = ({ title, address, nested = false }) => {
  const lines = formatAddressBlock(address);

  if (nested) {
    return (
      <div>
        {title ? <p className="text-xs text-gray-500">{title}</p> : null}
        {lines ? (
          <div className={cn('space-y-0.5', title && 'mt-0.5')}>
            {lines.map((line) => (
              <p key={line} className="text-sm font-medium text-gray-900">
                {line}
              </p>
            ))}
          </div>
        ) : (
          <p className={cn('text-sm font-medium text-gray-900', title && 'mt-0.5')}>
            —
          </p>
        )}
      </div>
    );
  }

  return (
    <div className="rounded-md border border-slate-200 bg-slate-50/60 p-3">
      <p className="text-xs text-gray-500">{title}</p>
      {lines ? (
        <div className="mt-2 space-y-0.5 text-sm text-gray-900">
          {lines.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>
      ) : (
        <p className="mt-2 text-sm text-gray-900">—</p>
      )}
    </div>
  );
};

CrmAddressCard.propTypes = {
  title: PropTypes.string.isRequired,
  address: PropTypes.object,
  nested: PropTypes.bool,
};

export default CrmAddressCard;
